import {
  Button,
  Divider,
  Flex,
  Form,
  InputNumber,
  Modal,
  Typography,
} from 'antd'
import { submitAddCoins } from 'src/pages/worldCup2026/participants/model'
import { Client } from 'src/pages/worldCup2026/types'

type Props = {
  client: Client | null
  onClose: () => void
}

type FormValues = {
  amount: number
}

export const AddCoinsModal = ({ client, onClose }: Props) => {
  const { Item } = Form
  const { Text } = Typography

  const handleSubmit = ({ amount }: FormValues) => {
    if (!client?.clientId) return
    submitAddCoins({ amount, id: client?.clientId })
    onClose()
  }

  return (
    <Modal
      title={<div style={{ fontSize: 20 }}>Add coins {client?.fullName}</div>}
      centered
      wrapClassName="ant_modal"
      width={600}
      maskClosable={false}
      open={Boolean(client)}
      onCancel={onClose}
      footer={null}
    >
      <Divider />
      <Form layout="vertical" onFinish={handleSubmit}>
        <Item
          required={false}
          name="amount"
          label={
            <Text style={{ fontSize: 16 }} strong>
              Enter Amount
            </Text>
          }
          rules={[
            {
              required: true,
              transform: (value) => value?.trim(),
              message: 'Required field',
            },
          ]}
        >
          <InputNumber />
        </Item>
        <Divider />
        <Flex gap={8} justify="flex-end">
          <Button onClick={onClose}>Cancel</Button>
          <Button color="blue" type="primary" htmlType="submit">
            Ok
          </Button>
        </Flex>
      </Form>
    </Modal>
  )
}
